import { computed, reactive, watch } from "vue";
import { useField, useForm } from "vee-validate";
import { useAuth, useAlertStore, useMetaStore } from "../../stores";
import { forgotPassword } from "../../Actions/AuthActions";
import { useRouter } from "vue-router";
export default {
  setup() {
    const alertStore = useAlertStore();
    const authStore = useAuth();
    const router = useRouter();
    const metaStore = useMetaStore();
    const marketplaceContent = computed(() => metaStore.marketplaceContent)
    const dialog = computed({
      get: () => authStore.forgotPasswordDialog,
      set: (value) => authStore.setForgotPasswordDialog(value),
    });

    const { handleSubmit, handleReset } = useForm({
      validationSchema: {
        input(value) {
          if (value?.length === 10) return true;
          return "Please enter a valid 10 digit mobile number.";
        },
      },
    });

    const input = useField("input");

    const submit = handleSubmit((values) => {
      forgotPassword({ mobile: values.input }).then((res) => {
        if (res.status === 200) {
          authStore.setForgotPasswordUser(values.input);
          authStore.setTransactionToken(res?.data?.transaction_token);
          authStore.setForgotPasswordDialog(false);
          authStore.setLoginDialog(false);
          alertStore.setAlertMessage("success", "An OTP code has been sent to your contact number.", true);
          authStore.setPasswordOTPDialog(true);
          input.resetField();
        } else {
          alertStore.setAlertMessage("error", res.data?.errors, true);
        }
      });
    });

    const handleRedirect = (page = "Login") => {
      if (page === "Login") {
        authStore.setLoginDialog(true);
      } else {
        router.push({ name: "SignUp" });
      }
      authStore.setForgotPasswordDialog(false);
    };

    watch(() => dialog.value, () => {
      input.resetField();
    })

    return {
      input,
      submit,
      dialog,
      handleRedirect,
      marketplaceContent
    };
  },
};